export function CardContent({ children }) {
  return <div className="p-4 space-y-4">{children}</div>;
}
